export const countryAndCapitalsTestSet: string[] = [
  "유럽에 있는 국가의 수도",
  "아시아에 있는 국가의 수도",
  "아프리카에 있는 국가의 수도",
  "남미에 있는 국가의 수도",
  "미국의 주 이름",
  "아프리카에 있는 국가",
  "중앙아시아에 있는 국가",
  "중앙아메리카에 있는 국가",
  "동남아시아에 있는 국가",
]